import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import notify from 'devextreme/ui/notify';
import { DataService } from '../shared/dataService';
@Component({
  selector: 'app-confirm-email',
  templateUrl: './confirm-email.component.html',
  styleUrls: ['./confirm-email.component.css']
})
export class ConfirmEmailComponent implements OnInit {

  public creds = {
    userId : "",
    newPassword : "",
    code : "",
    confirmPassword :""
  };
  public messageResult: string ="";
  public sendConfirm: boolean;
  constructor(private router:Router,private dataServer: DataService,private routeUrl: ActivatedRoute) { }

  ngOnInit() 
  {
    
    this.creds.code=this.routeUrl.snapshot.queryParams.code;
    this.creds.userId = this.routeUrl.snapshot.queryParams.userId;

    if (this.creds.code == undefined || this.creds.userId == undefined||
        this.creds.code == "" || this.creds.userId == "")
        return this.router.navigate(["/account"]);
  }
  passwordComparison = () => {
    return this.creds.newPassword;
};
  //onConfirmPassword
  onFormSubmit(event)
  {
   // console.log("Enviar contraseña nueva");
    //console.log(this.creds);
    //validate is equals   pass and confirmPass.
    this.messageResult ="Procesando la solicitud."
    this.dataServer.confirmEmail(this.creds)
      .subscribe(success=>
        {
          if(success)
          {
            //notify("¡Contraseña actualziada!");  
            this.messageResult= "¡Contraseña actualizada!";
          }
          else
          {
            //notify("¡Error ,  vuelva a intetarlo!");  
            this.messageResult= "¡Error ,  vuelva a intetarlo!";
          }
        },
        error=>
        {
          console.log(error);
          this.messageResult= "Error al procesar la solicitud.";
          //notify("¡Error interno!"); 
        });
    
    //this.router.navigate(["/account"]);
    this.sendConfirm = true;
  }
}